import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';

/**
 * Generated class for the TermsPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-terms',
  templateUrl: 'terms.html',
})
export class TermsPage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams
  ) {
  }

  onBack() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/terms/terms.ts